export interface StorySection {
  id: string;
  heading: string;
  paragraphs: readonly string[];
}

/**
 * Contenu original de /asterion — n'existe pas sur solutions-asterion.com,
 * donc indexable ici sans cannibaliser le site d'entreprise.
 * Angle personne : qui est l'auteur, pas catalogue produit.
 */
export const ASTERION_STORY: readonly StorySection[] = [
  {
    id: 'atelier',
    heading: 'Ça a commencé par un irritant, pas par une idée d’entreprise',
    paragraphs: [
      'Je n’ai pas fondé Asterion Solutions parce que j’avais envie de faire du logiciel. Je l’ai fondée parce que je perdais mes journées à faire des choses qu’une machine aurait dû faire à ma place.',
      'Pendant quatorze ans, j’ai été technicien en génie mécanique du côté de l’atelier : inspection dimensionnelle, dossiers qualité, non-conformités, étalonnage, ISO 9001. Hydro-Québec, GE, Voith, Andritz. Des pièces qui coûtent cher, des tolérances qui ne pardonnent pas, et des rapports à produire pour chacune.',
      'Le travail technique, je l’aimais. Ce que je ne supportais plus, c’était tout ce qu’il y avait autour : recopier trois fois la même cote, chercher un certificat matière dans un classeur, reconstruire à la main un rapport que le système aurait pu générer.',
    ],
  },
  {
    id: 'premier-outil',
    heading: 'Le premier outil, je l’ai écrit pour moi',
    paragraphs: [
      'J’ai appris à coder pour régler mon propre problème. Pas pour le vendre — pour arrêter de perdre des heures. Le premier outil lisait les cotes d’un plan et montait le rapport d’inspection tout seul.',
      'Il ne payait pas de mine. Mais il tournait dans un vrai atelier, sur de vraies pièces, avec de vrais délais. C’est la seule validation qui compte : un outil qui survit à une journée de production a déjà prouvé plus qu’une démo.',
      'Puis les collègues ont demandé à s’en servir. Puis d’autres ateliers.',
    ],
  },
  {
    id: 'asterion',
    heading: 'Pourquoi Asterion Solutions existe',
    paragraphs: [
      'Asterion Solutions est née de ce constat : les PME manufacturières achètent des ERP conçus pour des entreprises dix fois plus grosses, et finissent par gérer l’essentiel dans des fichiers Excel que personne n’ose toucher.',
      'Ce qui manque n’est presque jamais un gros système de plus. C’est une application dédiée, qui fait une chose, qui parle à l’ERP existant, et qui est livrée en jours plutôt qu’en trimestres.',
      'C’est ce que je construis. Le catalogue complet, les applications disponibles et les modalités sont sur le site de l’entreprise.',
    ],
  },
  {
    id: 'pourquoi-deux-sites',
    heading: 'Pourquoi deux sites',
    paragraphs: [
      'Asterion Solutions, c’est moi. Il n’y a pas d’équipe commerciale derrière, pas de fondateur figurant sur une page « à propos ».',
      'Ce site-ci répond à une seule question : qui est la personne qui écrit ce logiciel, et pourquoi la croire. Le site de l’entreprise répond à l’autre : qu’est-ce qu’elle vend, et à quelles conditions.',
      'Si vous cherchez une application métier pour votre atelier, c’est là qu’il faut aller. Si vous voulez d’abord savoir à qui vous parlez, vous êtes au bon endroit.',
    ],
  },
];
